import * as React from "react";
import {DataBaseComponent, DataBaseComponentState} from "components/DataBaseComponent";
import {HostedInstanceResource} from "client/resources/hostedInstanceResource";
import {HostedInstanceMasterKeyRequest} from "client/resources/hostedInstanceMasterKeyRequest";
import SaveDialogLayout from "components/DialogLayout/SaveDialogLayout";
import { Callout } from "@octopusdeploy/design-system-components";
import Sensitive from "components/Sensitive/Sensitive";
import repository from "client/repository";

interface UpdateMasterKeyDialogProps {
    instance: HostedInstanceResource;
}

interface UpdateMasterKeyDialogState extends DataBaseComponentState {
    changeMasterKeyRequest: Partial<HostedInstanceMasterKeyRequest>;
}

export class UpdateMasterKeyDialog extends DataBaseComponent<UpdateMasterKeyDialogProps, UpdateMasterKeyDialogState> {
    constructor(props: UpdateMasterKeyDialogProps) {
        super(props);
        this.state = {
            changeMasterKeyRequest: {}
        };
    }

    render() {
        return <SaveDialogLayout title={"Update Master Key"}
                                 busy={this.state.busy}
                                 errors={this.state.errors}
                                 saveButtonLabel={"Save"}
                                 cancelButtonLabel={"Cancel"}
                                 onSaveClick={() => this.changeMasterKey()}>

            <Callout type="warning" title="Destructive Action">
                This is a one way operation and it can result in a data loss.
            </Callout>

            <Callout type="information" title="Further Action">
                This change will be reflected in the Hosted Instance only when it gets re-provisioned.
            </Callout>

            <Sensitive label="Master Key"
                       hintText="Master Key"
                       value={this.state.changeMasterKeyRequest.MasterKey}
                       onChange={MasterKey => this.updateMasterKeyRequest({MasterKey})}
                       autoFocus={true}
            />
        </SaveDialogLayout>;
    }

    private updateMasterKeyRequest(update: Partial<HostedInstanceMasterKeyRequest>) {
        return this.setState(prevState => ({changeMasterKeyRequest: {...prevState.changeMasterKeyRequest, ...update}}));
    }

    private changeMasterKey = async (): Promise<boolean> => {
        return this.doBusyTask(async () => {
            await repository.HostedInstances.changeMasterKey(this.props.instance, this.state.changeMasterKeyRequest as HostedInstanceMasterKeyRequest);
            this.updateMasterKeyRequest({MasterKey: null});
        });
    }
}
